import React, { useState, useEffect } from "react";
import { StaticSelectInput } from "../../constant/SelectInput";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Modal } from "react-bootstrap";
import { getStandardCount } from "../../../services/StandardService";
import { standardDropdownOptions } from "../../constant/Variable";
import {
  approveStandardList,
  bulkApproveStandard,
} from "../../../services/StandardService";
import BISTable from "./Standards/BIS";
import RSNTable from "./Standards/RSN";
import IPSSTable from "./Standards/IPSS";
import CommonStandardTable from "./Standards/CommonStandard";

const PendingStandardPage = () => {
  const [selectedOption, setSelectedOption] = useState("BIS");
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedStandards, setSelectedStandards] = useState([]);
  const [standardTypeCount, setStandardTypeCount] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    setIsLoading(true);
    approveStandardList(selectedOption)
      .then((resp) => {
        setData(resp.data.results);
        setIsLoading(false);
      })
      .catch((error) => {
        if (error.response) {
          console.log(error.response.data.message);
          setIsLoading(false);
        } else {
          console.log(error);
        }
      });
  }, [selectedOption]);

  useEffect(() => {
    getStandardCount("Pending")
      .then((resp) => {
        setStandardTypeCount(resp.data.results);
      })
      .catch((error) => {
        if (error.response) {
          console.log(error.response.data.message);
        } else {
          console.log(error);
        }
      });
  }, []);

  const toggleModal = () => {
    setShowModal(!showModal);
  };



  const toggleCheckbox = (id) => {
    setSelectedStandards((prevSelected) => {
      if (prevSelected.includes(id)) {
        return prevSelected.filter((item) => item !== id);
      } else {
        return [...prevSelected, id];
      }
    });
  };

  const handleSelect = (_name, value, _) => {
    setSelectedOption(value);
  };

  const handleSelectAll = () => {
    if (selectedStandards.length === data.length) {
      setSelectedStandards([]);
    } else {
      setSelectedStandards(data.map((item) => item.id));
    }
  };

  const handleApprove = () => {
    bulkApproveStandard({ standard_id_list: selectedStandards })
      .then((resp) => {
        setData(data.filter((item) => !selectedStandards.includes(item.id)));
        setSelectedStandards([]);
        toast.success(resp.data.message);
      })
      .catch((error) => {
        toast.error(error.response.data.message);
      });
  };

  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <div className="col-xl-12">
            <div className="card">
              <div className="card-body p-0">
                <div className="tbl-caption d-flex justify-content-between text-wrap flex-column  flex-sm-row align-items-start align-items-sm-center p-3">
                  <div className="row w-50 mt-3">
                    <div className=" col-md-4 mt-2 ">
                      <div className="d-flex  align-items-center">
                        <button
                          type="button"
                          className="btn btn-outline-primary btn-circle"
                          onClick={() => navigate("/dashboard")}
                        >
                          <i className="fa-solid fa-arrow-left"></i>
                        </button>
                        <h4 className="mb-0 ms-2">Pending Standard</h4>
                      </div>
                    </div>

                    <div className="col-md-5 ">
                      <StaticSelectInput
                        setParentInputValue={handleSelect}
                        optionsList={standardDropdownOptions}
                        name="standard_type"
                        id="standard_type"
                        defaultValue={{
                          label: selectedOption,
                          value: selectedOption,
                        }}
                        isRequired={true}
                      />
                    </div>
                    <div className="col-md-2 text-primary c-pointer fs-3 mt-1" onClick={toggleModal}>
                        <i class="fa-solid fa-circle-info"></i>
                      </div>
                  </div>

                  <div className="d-flex align-items-start align-items-sm-center flex-column flex-sm-row">
                    <span className="badge badge-lg badge-circle badge-outline-info me-3">
                      selected {selectedStandards.length}
                    </span>
                    {selectedStandards.length > 0 && (
                      <button
                        className="btn btn-sm btn-primary"
                        onClick={handleApprove}
                      >
                        Approve
                      </button>
                    )}
                  </div>
                </div>

                {selectedOption === "BIS" ? (
                  <BISTable
                    selectedStandards={selectedStandards}
                    data={data}
                    isLoading={isLoading}
                    toggleCheckbox={toggleCheckbox}
                    handleSelectAll={handleSelectAll}
                    navigate={navigate}
                  />
                ) : selectedOption === "RSN" ? (
                  <RSNTable
                    selectedStandards={selectedStandards}
                    data={data}
                    isLoading={isLoading}
                    toggleCheckbox={toggleCheckbox}
                    handleSelectAll={handleSelectAll}
                    navigate={navigate}
                  />
                ) : selectedOption === "IPSS" ? (
                  <IPSSTable
                    selectedStandards={selectedStandards}
                    data={data}
                    isLoading={isLoading}
                    toggleCheckbox={toggleCheckbox}
                    handleSelectAll={handleSelectAll}
                    navigate={navigate}
                  />
                ) : (
                  <CommonStandardTable
                    selectedStandards={selectedStandards}
                    data={data}
                    type={selectedOption}
                    isLoading={isLoading}
                    toggleCheckbox={toggleCheckbox}
                    handleSelectAll={handleSelectAll}
                    navigate={navigate}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      <Modal
        className="modal fade"
        id="exampleModal1"
        show={showModal}
        onHide={toggleModal}
      >
        <div className="modal-content">
          <div className="modal-body">
            <table
              className="table table-sm table-bordered"
            >
              <thead>
                <tr>
                  <th>Standard Type</th>
                  <th>Count</th>
                </tr>
              </thead>
              {standardTypeCount && (
                <tbody>
                  <tr>
                    <td>BIS</td>
                    <td>{standardTypeCount.bis}</td>
                  </tr>
                  <tr>
                    <td>ASTM</td>
                    <td>{standardTypeCount.astm}</td>
                  </tr>
                  <tr>
                    <td>AWWA</td>
                    <td>{standardTypeCount.awwa}</td>
                  </tr>
                  <tr>
                    <td>BRITISH</td>
                    <td>{standardTypeCount.british}</td>
                  </tr>
                  <tr>
                    <td>DIN(GERMAN)</td>
                    <td>{standardTypeCount.din}</td>
                  </tr>
                  <tr>
                    <td>GOST(RUSSIAN)</td>
                    <td>{standardTypeCount.gost}</td>
                  </tr>
                  <tr>
                    <td>IEC</td>
                    <td>{standardTypeCount.iec}</td>
                  </tr>
                  <tr>
                    <td>ISO</td>
                    <td>{standardTypeCount.iso}</td>
                  </tr>
                  <tr>
                    <td>IRST</td>
                    <td>{standardTypeCount.irst}</td>
                  </tr>
                  <tr>
                    <td>API</td>
                    <td>{standardTypeCount.api}</td>
                  </tr>
                  <tr>
                    <td>PSN</td>
                    <td>{standardTypeCount.psn}</td>
                  </tr>
                  <tr>
                    <td>RSN</td>
                    <td>{standardTypeCount.rsn}</td>
                  </tr>
                  <tr>
                    <td>IPSS</td>
                    <td>{standardTypeCount.ipss}</td>
                  </tr>
                </tbody>
              )}
            </table>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default PendingStandardPage;
